import * as React from 'react';

export interface CurrencyProps extends React.HTMLAttributes<HTMLSpanElement> {
  value: string | number;
  currency?: string;
  language?: string;
}

export const formatCurrency = (
  value: string | number,
  currency: string = 'PLN',
  language: string = 'pl',
): string => {
  try {
    return new Intl.NumberFormat(language, {
      style: 'currency',
      currency: currency,
    }).format(Number(value));
  } catch (error) {
    console.error(`Invalid currency: ${currency}`, { cause: error });
    return `${value} ${currency}`;
  }
};

const CurrencyFormatted: React.FC<CurrencyProps> = ({ value, currency, language, ...rest }) => {
  const selectedLanguage = language || localStorage.getItem('language') || 'pl';
  return <span {...rest}>{formatCurrency(value, currency, selectedLanguage)}</span>;
};

export { CurrencyFormatted };
